import { API_URL } from '../../utils/config';
import React from 'react';
import axios from 'axios';
import { Button, Modal, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

var WydrukKlient = React.createClass({

	getInitialState: function() {
		this.getDictListwy();
		return {
			items: [],
			dataDictListwy: null
		}
    },

		punktNrTel: function(punkt) {
			if (punkt === 'Castorama') return '533-972-777';
			if (punkt === 'Arena') return '796-927-777';
			if (punkt === 'Domar') return '884-667-557';
			return '';
		},

		renderOne: function(item, idx, total) {
			var w = item.wydruk;
			var p = item.platnosci;
			var fmt = function(v) { var n = parseFloat(v); return (!n || isNaN(n)) ? '-' : n.toFixed(2) + ' zł'; };
			var wielokrotnosc = w.iloscSztuk > 1;
			var extraRows = 0;
			if (parseFloat(p.kosztSzlifu) > 0) extraRows++;
			if (parseFloat(p.kosztFazy) > 0) extraRows++;
			if (parseFloat(p.kosztKrosna) > 0) extraRows++;
			if (parseFloat(p.kosztFolii) > 0) extraRows++;
			if (wielokrotnosc) extraRows += 2;
			var telefonRowSpan = 4 + extraRows;
			var pageBreak = idx < total - 1 ? { pageBreakAfter: 'always' } : {};

			return (
				<div key={w.id} className="wydruk-page" style={pageBreak}>
					<table>
					<tbody>
						<tr>
							<td>Data: </td>
							<td>{w.dataZlozenia}</td>
							<td><strong>Numer zamówienia: </strong></td>
							<td><strong>{w.id}</strong></td>
						</tr>
						<tr>
							<td rowSpan="4">Imię i nazwisko: </td>
							<td rowSpan="4">{w.imie} {w.nazwisko}</td>
							<td>Cena listwy: </td>
							<td>{fmt(p.kosztListwy)}</td>
						</tr>
						<tr>
							<td>Cena szkła: </td>
							<td>{fmt(p.kosztSzkla)}</td>
						</tr>
						<tr>
							<td>Cena HDF: </td>
							<td>{fmt(p.kosztHdf)}</td>
						</tr>
						<tr>
							<td>Cena zawieszki: </td>
							<td>{fmt(p.kosztZawieszki)}</td>
						</tr>
						<tr>
							<td rowSpan={telefonRowSpan}><strong>Telefon: </strong></td>
							<td rowSpan={telefonRowSpan}><strong>{w.telefon}</strong></td>
							<td>Cena lustra: </td>
							<td>{fmt(p.kosztLustra)}</td>
						</tr>
						<tr>
							<td>Cena passe partout: </td>
							<td>{fmt(p.kosztPass)}</td>
						</tr>
						{parseFloat(p.kosztSzlifu) > 0 ? <tr>
							<td>Cena szlifu: </td>
							<td>{fmt(p.kosztSzlifu)}</td>
						</tr> : null}
						{parseFloat(p.kosztFazy) > 0 ? <tr>
							<td>Cena fazy: </td>
							<td>{fmt(p.kosztFazy)}</td>
						</tr> : null}
						{parseFloat(p.kosztKrosna) > 0 ? <tr>
							<td>Cena krosna: </td>
							<td>{fmt(p.kosztKrosna)}</td>
						</tr> : null}
						{parseFloat(p.kosztFolii) > 0 ? <tr>
							<td>Cena folii: </td>
							<td>{fmt(p.kosztFolii)}</td>
						</tr> : null}
						<tr>
							<td>Cena usługi: </td>
							<td>{fmt(w.kosztUslugi)}</td>
						</tr>
						{wielokrotnosc ? <tr>
							<td>Cena za sztukę: </td>
							<td>{fmt(parseFloat(w.cena) / parseInt(w.iloscSztuk))}</td>
						</tr> : null}
						{wielokrotnosc ? <tr>
							<td>Ilość sztuk: </td>
							<td>{w.iloscSztuk}</td>
						</tr> : null}
						<tr>
							<td><strong>{wielokrotnosc ? 'Razem:' : 'Wartość zamówienia:'} </strong></td>
							<td><strong>{fmt(w.cena)}</strong></td>
						</tr>
						<tr>
							<td rowSpan="2">Email: </td>
							<td rowSpan="2">{w.email}</td>
							<td>Data odbioru: </td>
							<td>{w.dataOdbioru}</td>
						</tr>
						<tr>
							<td>Wpłacona zaliczka: </td>
							<td>{fmt(w.zaliczka)}</td>
						</tr>
						<tr>
							<td rowSpan="2">NIP: </td>
							<td rowSpan="2">{w.nip}</td>
							<td><strong>Numer listwy: </strong></td>
							<td><strong>{w.numerListwy}</strong></td>
						</tr>
						<tr>
							<td>Numer passe partout: </td>
							<td>{w.numerPass}</td>
						</tr>
						<tr>
							<td colSpan="2"><strong>Uwagi: </strong></td>
							<td colSpan="2">Podpis: </td>
						</tr>
						<tr style={{height: '120px'}}>
							<td colSpan="2" style={{verticalAlign: 'top'}}><strong>{w.uwagi}</strong></td>
							<td colSpan="2"></td>
						</tr>
						<tr>
							<td colSpan="2">Punkt sprzedaży: {w.punktSprzedazy}</td>
							<td colSpan="2">Sprzedawca: {w.operator}</td>
						</tr>
						<tr>
							<td colSpan="2">Telefon: </td>
							<td>{this.punktNrTel(w.punktSprzedazy)}</td>
							<td>600-803-231</td>
						</tr>
						</tbody>
						</table>
						<div className="rodo">
							Wyrażam zgodę na przetwarzanie moich danych osobowych: imię, nazwisko,<br/>
							numer telefonu przez Derame Jerzy Czupik, 55-200 Oława, ul.Iwaszkiewicza 41/6<br/>
							w celu realizacji mojego zamówienia.<br/>
							Zgoda ta jest dobrowolna i może zostać wycofana w każdej chwili.
						</div>
				</div>
			);
		},

		render: function() {
			var items = this.state.items;
			var total = items.length;
			var title = total > 1
				? 'Wydruk dla Klienta - ' + total + ' zleceń'
				: 'Wydruk dla Klienta - Zlecenie nr ' + (items[0] ? items[0].wydruk.id : '');
			var self = this;
			return (
				<Modal show={this.props.parent.state.showWydrukKlientModal} bsSize={total > 1 ? 'large' : null}>
					<Modal.Header>
						<Modal.Title>{title}</Modal.Title>
					</Modal.Header>
					<Modal.Body style={{maxHeight: '70vh', overflowY: 'auto'}}>
					<div id="printable">
					<style>{'#printable .wydruk-page{margin-bottom:20px;}#printable table{width:100%;border-collapse:collapse;table-layout:fixed;font-family:Arial,sans-serif;font-size:16px;color:#000;}#printable td{border:1px solid #000;padding:6px 10px;vertical-align:middle;word-wrap:break-word;overflow:hidden;}#printable .rodo{margin-top:10px;font-size:12px;line-height:1.35;}'}</style>
					{items.map(function(it, idx) { return self.renderOne(it, idx, total); })}
					</div>

					</Modal.Body>
					<Modal.Footer>
						<Button onClick={this.props.parent.closeWydrukKlientModal}>Zamknij</Button>
						<Button bsStyle="primary" onClick={this.onDrukujBtnClicked}>Drukuj{total > 1 ? ' (' + total + ')' : ''}</Button>
					</Modal.Footer>
				</Modal>
			);
		},

	buildItem: function(selectedZlecenie) {
		var wydruk = {
			id: selectedZlecenie.id,
			cena: selectedZlecenie.cena,
			czyZdjecie: selectedZlecenie.czyZdjecie,
			grubosc: selectedZlecenie.grubosc,
			hdf: selectedZlecenie.hdf,
			kosztUslugi: selectedZlecenie.kosztUslugi,
			lustro: selectedZlecenie.lustro,
			numerListwy: selectedZlecenie.numerListwy,
			numerPass: selectedZlecenie.numerPass,
			operator: selectedZlecenie.operator,
			punktSprzedazy: selectedZlecenie.punktSprzedazy,
			szerokosc: selectedZlecenie.szerokosc,
			szklo: selectedZlecenie.szklo,
			uwagi: selectedZlecenie.uwagi,
			wysokosc: selectedZlecenie.wysokosc,
			zawieszka: selectedZlecenie.zawieszka,
			dataZlozenia: selectedZlecenie.dataZlozenia,
			imie: selectedZlecenie.imie,
			nazwisko: selectedZlecenie.nazwisko,
			telefon: selectedZlecenie.telefon,
			pozostalaDoplata: selectedZlecenie.pozostalaDoplata,
			dataOdbioru: selectedZlecenie.dataOdbioru,
			czyPass: selectedZlecenie.czyPass,
			zaliczka: selectedZlecenie.zaliczka,
			email: selectedZlecenie.email || '',
			nip: selectedZlecenie.nip || '',
			szlif: selectedZlecenie.szlif || false,
			faza: selectedZlecenie.faza || false,
			krosno: selectedZlecenie.krosno || false,
			folia: selectedZlecenie.folia || false,
			iloscSztuk: selectedZlecenie.iloscSztuk || 1,
		};

		var dictListwa = this.getListwaByNrListwy(wydruk.numerListwy);
		var dlListwy = (parseFloat(parseFloat(wydruk.wysokosc * 2) + parseFloat(wydruk.szerokosc * 2)) + parseFloat(wydruk.grubosc * 8)) / 100;
		var kosztListwy = dictListwa && dictListwa !== 'brak' ? (dlListwy * parseFloat(dictListwa.cenaZaMb)) : 0.00;
		var pole = parseFloat((wydruk.wysokosc / 100) * (wydruk.szerokosc) / 100);
		var kosztSzkla = 0.00;
		if (wydruk.szklo && wydruk.szklo == 'Zwykłe') kosztSzkla = parseFloat(80 * pole);
		if (wydruk.szklo && wydruk.szklo == 'Antyrefleks') kosztSzkla = parseFloat(120 * pole);
		if (wydruk.szklo && wydruk.szklo == 'Muzealne') kosztSzkla = parseFloat(600 * pole);
		if ((wydruk.szklo == 'Wybierz typ') || (wydruk.szklo == 'NIE')) kosztSzkla = 0.00;

		var platnosci = {
			kosztListwy: isNaN(kosztListwy) ? 0.00 : kosztListwy,
			kosztSzkla: isNaN(kosztSzkla) ? 0.00 : kosztSzkla,
			kosztHdf: wydruk.hdf ? parseFloat(78 * pole) : 0.00,
			kosztZawieszki: wydruk.zawieszka ? parseFloat(3.10) : 0.00,
			kosztLustra: wydruk.lustro ? parseFloat(200 * pole) : 0.00,
			kosztPass: wydruk.czyPass ? parseFloat(90 * pole) : 0.00,
			kosztSzlifu: wydruk.szlif ? parseFloat(30 * dlListwy) : 0.00,
			kosztFazy: wydruk.faza ? parseFloat(50 * dlListwy) : 0.00,
			kosztKrosna: wydruk.krosno ? parseFloat(35 * dlListwy) : 0.00,
			kosztFolii: wydruk.folia ? parseFloat(15 * pole) : 0.00,
		};

		return { wydruk: wydruk, platnosci: platnosci };
	},

	fillWydrukKlientObject: function() {
		var self = this;
		var ids = this.props.parent.state.selectedZlecenieIds || [];
		var items = ids.map(function(id) {
			var z = self.props.parent.getZlecenieById(id);
			return z ? self.buildItem(z) : null;
		}).filter(function(it) { return it !== null; });
		this.setState({ items: items });
	},

	clearWydrukKlientObject: function() {
		this.setState({ items: [] });
	},

	getDictListwy: function() {
		axios.get(API_URL + '/dictListwy')
		.then(function (dictListwa) {
			this.setState({dataDictListwy: dictListwa.data});
		}.bind(this));
	},

	getListwaByNrListwy: function(numerListwy) {
		for(var i in this.state.dataDictListwy) {
			if(this.state.dataDictListwy[i].numerListwy == numerListwy) {
				return this.state.dataDictListwy[i];
			}
		}
		return 'brak';
	},

	onDrukujBtnClicked: function() {
		var printContents = document.getElementById('printable').innerHTML;
		var win = window.open('', 'PRINT');
		win.document.write('<html><head><title>Wydruk klient</title>');
		win.document.write('<style>body{font-family:Arial,sans-serif;margin:14px;color:#000;}.wydruk-page{page-break-after:always;}.wydruk-page:last-child{page-break-after:auto;}table{width:100%;border-collapse:collapse;table-layout:fixed;font-size:16px;page-break-inside:avoid;}td{border:1px solid #000;padding:6px 10px;vertical-align:middle;word-wrap:break-word;overflow:hidden;}.rodo{margin-top:10px;font-size:12px;line-height:1.35;}</style>');
		win.document.write('</head><body>');
		win.document.write(printContents);
		win.document.write('</body></html>');
		win.document.close();
		win.focus();
		win.print();
		win.close();
		this.props.parent.closeWydrukKlientModal();
	}
});

export default WydrukKlient;



// WEBPACK FOOTER //
// ./src/components/Zlecenie/WydrukKlient.js